/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { SelectOption } from '../../types/DropDownTypes'
import { DeviceTravel, TravelLocation, DeviceTravelPolicy, TravelEvent } from '../../types/TravelTypes'

export interface TravelMembersFilters {
  countries: SelectOption[]
  risk: SelectOption[]
  travelGuide: SelectOption[]
  travelPolicy: DeviceTravelPolicy | undefined
}

export interface TravelEventsFilters {
  countries: SelectOption[]
  risk: SelectOption[]
  fromDateTime?: string
  toDateTime?: string
}

export interface TravelState {
  travelDevices: DeviceTravel[]
  travelPolicies: DeviceTravelPolicy[] | undefined
  travelMembers: DeviceTravel[]
  travelEvents: TravelEvent[] | undefined
  mapLocations: TravelLocation[]
  travelLocationOptions: SelectOption[]
  travelMembersTotalPages: number
  travelEventsTotalPages: number
  travelTableCurrentPage: number
  eventsTableCurrentPage: number
  membersFilters: TravelMembersFilters
  eventsFilters: TravelEventsFilters
  travelPolicy: DeviceTravelPolicy | undefined
}

const initialState: TravelState = {
  travelPolicy: undefined,
  travelPolicies: undefined,
  travelDevices: [],
  travelMembers: [],
  travelEvents: undefined,
  mapLocations: [],
  travelLocationOptions: [],
  travelMembersTotalPages: 1,
  travelEventsTotalPages: 1,
  travelTableCurrentPage: 0,
  eventsTableCurrentPage: 0,
  membersFilters: {
    countries: [],
    risk: [],
    travelGuide: [],
    travelPolicy: undefined,
  },
  eventsFilters: {
    countries: [],
    risk: [],
  },
}

export const travelSlice = createSlice({
  name: 'travel',
  initialState,
  reducers: {
    setTravelMembers(state, action: PayloadAction<any>) {
      state.travelMembers = action.payload
    },
    setTravelEvents(state, action: PayloadAction<TravelEvent[] | undefined>) {
      state.travelEvents = action.payload
    },
    setMapLocations(state, action: PayloadAction<any>) {
      state.mapLocations = action.payload
    },
    setTravelLocationOptions(state, action: PayloadAction<any>) {
      state.travelLocationOptions = action.payload
    },
    setTravelPolicy(state, action: PayloadAction<DeviceTravelPolicy | undefined>) {
      state.travelPolicy = action.payload
    },
    setTravelPolicies(state, action: PayloadAction<DeviceTravelPolicy[] | undefined>) {
      state.travelPolicies = action.payload
    },
    setTravelMembersTotalPages(state, action: PayloadAction<any>) {
      state.travelMembersTotalPages = action.payload
    },
    setTravelMembersTableCurrentPage(state, action: PayloadAction<any>) {
      state.travelTableCurrentPage = action.payload
    },
    setTravelEventsTotalPages(state, action: PayloadAction<number>) {
      state.travelEventsTotalPages = action.payload
    },
    setTravelEventsTableCurrentPage(state, action: PayloadAction<number>) {
      state.eventsTableCurrentPage = action.payload
    },
    setTravelMembersFilters(state, action: PayloadAction<any>) {
      state.membersFilters = action.payload
    },
    setTravelEventsFilters(state, action: PayloadAction<any>) {
      state.eventsFilters = action.payload
    },
  },
})
export const selectTravel = (state: RootState) => state.travel

export const {
  setTravelMembers,
  setTravelEvents,
  setTravelLocationOptions,
  setMapLocations,
  setTravelPolicy,
  setTravelPolicies,
  setTravelMembersTotalPages,
  setTravelEventsTotalPages,
  setTravelMembersTableCurrentPage,
  setTravelEventsTableCurrentPage,
  setTravelMembersFilters,
  setTravelEventsFilters,
} = travelSlice.actions
export default travelSlice.reducer
